import React, { useEffect, useRef, useState } from "react";
import style from "./header.module.css";
import { Link } from "react-router-dom";
import { isAbsoluteUrl } from "../services/urlService";
import { NavDropdown } from "react-bootstrap";

interface MenuDropDownPropsDI {
  main: { text: string; link?: string | null };
  secondary: Array<{
    text: string;
    link?: string | null;
    url?: string | null;
    isNewTab?: boolean | null;
  }>;
  [index: string]: any;
  id?: string;
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const MenuDropDown: React.FC<MenuDropDownPropsDI> = (props) => {
  const mainLinkElement = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    props.secondary.map(item => {
      if (mainLinkElement.current && item.url?.includes(decodeURI(window.location.pathname)) && window.location.pathname !== "/") {
        mainLinkElement.current.className = "selected";
      }
    });
    return () => {
      if (mainLinkElement.current) {
        mainLinkElement.current.className = "";
      }
    };
  }, [mainLinkElement.current, window.location.pathname]);

  const isHeaderClicked = (event: PointerEvent) => {
    const clickedElement = event.target;
    return (clickedElement as Element).classList.contains("dropdown-toggle"); //this is the class of the header link.
  };

  return (
    <div ref={mainLinkElement}>
      <NavDropdown
        title={props.main.text}
        className={`${style.menuButton} ${
          props.isOpen && !isOpen ? style.menuButton__disableHover : "" //if another tab is open disable hover.
        }`}
        renderMenuOnMount={true}
        onToggle={(toggle, meta) => {
          if (meta.source === "click" || meta.source === "keydown") {
            props.setIsOpen(!(isOpen && props.isOpen));
          }
          if (meta.source === "rootClose") {
            if (!isHeaderClicked(meta?.originalEvent as PointerEvent)) {
              props.setIsOpen(false);
            }
          }
          setIsOpen(toggle);
        }}
      >
        {props.secondary.map((item, i) => {
          if (item.url) {
            return (
              <>
                {isAbsoluteUrl(item.url) ? (
                  <NavDropdown.Item
                    key={i + item.text}
                    href={item.url}
                    target={!props.isNewTab ? "_blank" : ""}
                  >
                    {item.text}
                  </NavDropdown.Item>
                ) : (
                  <NavDropdown.Item key={i + item.text} as={Link} to={item.url}>
                    {item.text}
                  </NavDropdown.Item>
                )}
                {props.secondary.length > 1 && i !== props.secondary.length - 1 && <NavDropdown.Divider key={i + item.text + i} />}
              </>
            );
          }
        })}
      </NavDropdown>
    </div>
  );
};

export default MenuDropDown;
